import React, { useState } from "react";
import { Eye, EyeOff } from "lucide-react";
import "./PasswordInput.css";

// A password field with a Show/Hide button, so people can check what they
// typed. Takes the same props as an <input>; className styles the input.
const PasswordInput = ({ id, className = "auth-input", ...props }) => {
  const [shown, setShown] = useState(false);
  const Icon = shown ? EyeOff : Eye;
  return (
    <div className="password-input">
      <input id={id} className={className} {...props} type={shown ? "text" : "password"} />
      <button
        type="button"
        className="password-input__toggle"
        onClick={() => setShown((s) => !s)}
        aria-label={shown ? "Hide password" : "Show password"}
        aria-controls={id}
      >
        <Icon size={18} aria-hidden="true" />
        <span aria-hidden="true">{shown ? "Hide" : "Show"}</span>
      </button>
    </div>
  );
};

export default PasswordInput;
